// extracted by mini-css-extract-plugin
export default {"root":"q8hLCXk9","icon":"MjsyRMSF","subtitle":"TXNdc84p"};